export const APP_ID = "data-access-xleho"
export const GRAPHQL_ENDPOINT = "https://us-east-1.aws.realm.mongodb.com/api/client/v2.0/app/data-access-xleho/graphql"